import { ensureTrailingSlash } from '../../utils/url/url';
import Rest from '../../utils/rest/rest';

const baseURL = ensureTrailingSlash(process.env.REACT_APP_API_URL);

export const getAllOrganizations = async () => {
  const path = baseURL + 'api/v1/org';
  return await Rest.get(path);
};

export const getOrganization = async (organizationId) => {
  const path = baseURL + 'api/v1/org/' + organizationId;
  return await Rest.get(path);
};

export const createOrganization = async ({ name, description }) => {
  const path = baseURL + 'api/v1/org';
  const body = { name, description };
  return await Rest.post(path, body);
};

export const updateOrganization = async ({ _id, name, description }) => {
  const path = baseURL + 'api/v1/org/' + _id;
  const body = { name, description };
  return await Rest.put(path, body);
};

export const deleteOrganization = async (organizationId) => {
  const path = baseURL + 'api/v1/org/' + organizationId;
  return await Rest.delete(path);
};

export const getSessions = async (organizationId, startDate, endDate, interpreter, loadExcel) => {
  const path = baseURL + 'api/v1/org/' + organizationId + '/sessions';
  const params = { startDate, endDate };
  if (interpreter) {
    params.interpreter = interpreter;
  }
  if (loadExcel) {
    params.excel = 1;
  }
  return await Rest.get(path, { params });
};

export const createUser = async (
  organizationId,
  { username, firstname, lastname, phoneNumber, isAdmin }
) => {
  const path = baseURL + 'api/v1/org/' + organizationId + '/user';
  const body = { username, firstname, lastname, phoneNumber, isAdmin };
  return await Rest.post(path, body);
};

export const addUserToOrganization = async (userId, organizationId, isAdmin) => {
  const path = baseURL + 'api/v1/org/' + organizationId + '/user/' + userId;
  const body = { isAdmin };
  return await Rest.put(path, body);
};

export const removeUserFromOrganization = async (userId, organizationId) => {
  const path = baseURL + 'api/v1/org/' + organizationId + '/user/' + userId;
  return await Rest.delete(path);
};

export const updateUser = async (
  userId,
  organizationId,
  { username, firstname, lastname, phoneNumber, isAdmin }
) => {
  const path = baseURL + 'api/v1/org/' + organizationId + '/user/' + userId;
  const body = { username, firstname, lastname, phoneNumber, isAdmin };
  return await Rest.post(path, body);
};

export const checkUser = async (email) => {
  const path = baseURL + 'api/v1/org/user/' + encodeURIComponent(email);
  return await Rest.get(path);
};
